import { useEffect, useState } from 'react'
import { useRouterState } from '@tanstack/react-router'
import { WifiOff } from 'lucide-react'
import { m } from '#/paraglide/messages'

/** Foreground navigation only. Polling and hover preloads never light up this bar. */
export function NavigationProgress() {
  const pending = useRouterState({ select: (s) => s.status === 'pending' })
  const [visible, setVisible] = useState(false)
  useEffect(() => {
    if (!pending) {
      setVisible(false)
      return
    }
    const timer = window.setTimeout(() => setVisible(true), 250)
    return () => window.clearTimeout(timer)
  }, [pending])
  return visible && pending ? (
    <div
      className="pointer-events-none fixed inset-x-0 top-0 z-[100]"
      role="status"
      aria-live="polite"
      data-testid="navigation-progress"
    >
      <span className="sr-only">{m.loading_navigation()}</span>
      <div className="loading-track h-0.5 overflow-hidden bg-primary/10">
        <span className="loading-track-bar block h-full w-1/3 bg-primary" />
      </div>
    </div>
  ) : null
}

export function ConnectionStatus() {
  const [offline, setOffline] = useState(false)
  useEffect(() => {
    const sync = () => setOffline(!navigator.onLine)
    sync()
    window.addEventListener('online', sync)
    window.addEventListener('offline', sync)
    return () => {
      window.removeEventListener('online', sync)
      window.removeEventListener('offline', sync)
    }
  }, [])
  return offline ? (
    <div
      role="status"
      className="fixed inset-x-3 bottom-4 z-[90] mx-auto flex max-w-lg items-start gap-2 rounded-xl border bg-card p-3 text-sm shadow-sm"
    >
      <WifiOff className="mt-0.5 size-4 shrink-0" />
      <span>{m.loading_offline()}</span>
    </div>
  ) : null
}
